import MuiTypography from "@mui/material/Typography";
import type { TypographyProps } from "@mui/material/Typography";

const Typography = MuiTypography;

export { TypographyProps };
export default Typography;
